module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('el-popover', {
    ref: "popoveruser",
    staticClass: "userinfo",
    attrs: {
      "placement": "bottom",
      "trigger": "click"
    },
    model: {
      value: (_vm.isShowUserInfoPopover),
      callback: function($$v) {
        _vm.isShowUserInfoPopover = $$v
      },
      expression: "isShowUserInfoPopover"
    }
  }, [_c('div', {
    staticClass: "referral-userinfo-popover"
  }, [_c('label', {
    attrs: {
      "for": "user-name"
    }
  }, [_vm._v("User name"), _c('span', {
    attrs: {
      "id": "user-name"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])]), _c('label', {
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Email"), _c('span', {
    attrs: {
      "id": "email"
    }
  }, [_vm._v(_vm._s(_vm.user.email))])]), _c('label', {
    attrs: {
      "for": "user-status"
    }
  }, [_vm._v("Status"), _c('span', {
    attrs: {
      "id": "user-status"
    }
  }, [_vm._v(_vm._s(_vm.user.status))])])])]), _c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    }
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "110px",
      "height": "32px"
    },
    attrs: {
      "src": _vm.imgVipkidLogo
    }
  }), _c('el-menu-item', {
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "index": "3"
    }
  }, [_c('b', {
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v("Logout")])]), _c('el-menu-item', {
    staticClass: "arrow",
    attrs: {
      "index": "2"
    }
  }, [_c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popoveruser",
      arg: "popoveruser"
    }]
  }, [_c('span', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("My account")]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowUserInfoPopover),
      expression: "!isShowUserInfoPopover"
    }],
    staticClass: "el-icon-arrow-down"
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUserInfoPopover),
      expression: "isShowUserInfoPopover"
    }],
    staticClass: "el-icon-arrow-up"
  })])]), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('el-button', {
    staticClass: "copy-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onCopyReferralLink($event)
      }
    }
  }, [_vm._v("Copy Referral Link\n"), _c('svg', {
    staticClass: "icon-link",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.248 8.934l-2.423 2.422a3.435 3.435 0 0 0 0 4.854 3.434 3.434 0 0 0 4.854 0l2.986-2.986a3.435 3.435 0 0 0-.208-5.044l-1.41 1.373a1.653 1.653 0 0 1 .241 2.532L7.54 14.834a1.653 1.653 0 0 1-2.337-2.337l1.433-1.434a1.608 1.608 0 0 1-.208-.313l-.038-.074c-.262-.51-.298-1.158-.14-1.742z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.707 11.182L16.12 8.77a3.435 3.435 0 0 0 0-4.854 3.434 3.434 0 0 0-4.853 0L8.28 6.902a3.435 3.435 0 0 0 .5 5.266l1.427-1.428a1.653 1.653 0 0 1-.55-2.699l2.749-2.749a1.653 1.653 0 0 1 2.337 2.337L13.31 9.064l.307.824c.144.386.167.846.09 1.295z"
    }
  })])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27ce7283!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = 294
// module chunks = 2